import React, { useState, useEffect } from 'react';
import { isEmpty, uniqBy } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Accordion, Card, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import Select from 'react-select';
import PerfectScrollbar from 'react-perfect-scrollbar';
import BtnAdd from '../../Components/Utility/FilterAction/BtnAdd';
import * as action from './Store/SystemMasters.action';
import Loader from '../../Components/Utility/Loader/Loader';
import { SystemMasterSelect } from '../../Components/helper';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';
import CustomTooltip from '../../Components/Tooltip/CustomTooltip';

const tempObj = {
  name: null,
  isEmpty: false,
  isNew: true,
  isActive: true,
  hasLength: false,
  _id: '',
};

function CompositionMaster() {
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const materialCompositionComponent = 'material-composition-component';
  const {
    SystemMastersDetails,
    UserDetails,
    Users: { logInRights },
  } = reducer;
  const { compositionsList, BOMTypeList } = SystemMastersDetails;
  const { userInfo } = UserDetails;

  const { t } = useTranslation('common');
  const loggedInUserId = userInfo.userId;

  const [isLoadingComp, setIsLoadingComp] = useState(false);
  const [showComposition, setShowComposition] = useState(false);
  const [isCompositionsUnique, setIsCompositionsUnique] = useState(true);
  const [buttonDownComposition, setButtonDownComposition] = useState(true);
  const [addingCompositions, setAddingCompositions] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isComp, setIsComp] = useState(false);
  const [compositionsData, setCompositionsData] = useState([]);
  const [isUniqCompId, setIsUniqCompId] = useState([]);
  const [bomSubTypeSelectData, setbomSubTypeSelectData] = useState(null);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const [scrollEl, setScrollEl] = useState();
  const [sTBtnDisable, setSTBtnDisable] = useState(false);
  const { CheckActionPermission } = useComponent();
  const [userRights, setUserRights] = useState({});
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);

  const MasterAddEditAccess = CheckActionPermission(userRights, 'masters', 'composition', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(userRights, 'masters', 'composition', 'addEdit');
  useEffect(() => {
    if (scrollEl) {
      scrollEl.scrollTop = 1000;
    }
  }, [scrollEl]);
  useEffect(() => {
    setCompositionsData(uniqBy(compositionsList, 'name'));
    if (addingCompositions) {
      const dataObj = [
        ...compositionsList,
        {
          name: null,
          isEmpty: false,
          isNew: true,
          isActive: true,
          _id: '',
        },
      ];
      setCompositionsData(dataObj);
    }
  }, [compositionsList, addingCompositions]);

  const callApi = async () => {
    setButtonDownComposition(!buttonDownComposition);
    setIsLoadingComp(true);
    buttonDownComposition ? setShowComposition(true) : setShowComposition(false);
    const bomTypeparams = {
      isAllRecord: true,
    };
    if (isEmpty(compositionsData)) {
      await dispatch(action.getBOMTypeDetails(bomTypeparams));
    }
    setIsLoadingComp(false);
  };

  const handleChanged = (event, i) => {
    const composition = [...compositionsData];
    setIsCompositionsUnique(true);
    setIsUniqCompId([]);
    composition[i] = {
      ...composition[i],
      name: event.target.value,
      isEmpty: event.target.value === '',
    };
    const arr = [];
    const arrIndex = [];
    composition.forEach((ele, ind) => {
      composition.forEach((objs, index) => {
        if (ele.name === objs.name && ind !== index) {
          arr.push(ele);
          arrIndex.push(index);
        }
      });
    });

    if (!isEmpty(arr)) {
      const arrs = [...arrIndex];
      const removeArss = Math.min(...arrs);
      const newArr = arrIndex.filter((ele) => ele !== removeArss);
      setIsUniqCompId([...newArr]);
    }
    setIsCompositionsUnique(isEmpty(arr));

    let isDisableST = false;
    composition.forEach((STElement) => {
      if (isEmpty(STElement?.name?.trim())) {
        isDisableST = true;
      }
    });
    setSTBtnDisable(isDisableST);
    composition[i] = {
      ...composition[i],
      name: event.target.value,
      isEmpty: event.target.value === '',
    };
    setCompositionsData(composition);
  };

  useEffect(() => {
    bomSubTypeSelectData && Object.keys(bomSubTypeSelectData).length && compositionCalled();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bomSubTypeSelectData]);

  const compositionCalled = async () => {
    const cParams = {
      loggedInUserId,
      bomTypeId: bomSubTypeSelectData._id,
    };
    await dispatch(action.getCompositionsDetails(cParams));
  };

  const addComp = async () => {
    if (!showComposition) {
      setAddingCompositions(true);
      setButtonDownComposition(!buttonDownComposition);
      setIsLoadingComp(true);
      buttonDownComposition ? setShowComposition(true) : setShowComposition(false);
      const bomTypparams = {
        isAllRecord: true,
      };
      if (isEmpty(compositionsData)) {
        await dispatch(action.getBOMTypeDetails(bomTypparams));
      }
      setIsLoadingComp(false);
    } else if (!isEmpty(compositionsData)) {
      setCompositionsData([...compositionsData, tempObj]);
    } else {
      setCompositionsData([tempObj]);
    }
  };

  const handleDelete = (id) => {
    if (typeof id === 'number' || id === '') {
      compositionsData.splice(id, 1);
      setIsUniqCompId([]);
      setIsCompositionsUnique(true);
      setCompositionsData([...compositionsData]);
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  const saveComp = async () => {
    setIsComp(true);
    if (!isEmpty(compositionsData)) {
      const emptyField = await compositionsData?.filter((comitem) => comitem.name === null || comitem.name === '');

      if (isEmpty(emptyField)) {
        const data = compositionsData?.map((compobj) => {
          return { ...compobj, name: compobj?.name?.trim() };
        });
        const compositionParams = {
          loggedInUserId,
          names: JSON.stringify(data),
          bomTypeId: bomSubTypeSelectData._id,
          title: materialCompositionComponent,
        };
        setCompositionsData([]);
        setAddingCompositions(false);
        await dispatch(action.saveToSystemMaster(compositionParams, t));
        await compositionCalled();
        // post API
      } else {
        const newState = compositionsData.map((cmpobj) => (cmpobj?.isEmpty === false && cmpobj.name === null ? { ...cmpobj, isEmpty: true } : cmpobj));
        setCompositionsData(newState);
      }
    }
    setIsComp(false);
  };

  useEffect(() => {
    const array = [];
    compositionsData?.forEach((ele, index) => {
      compositionsData?.forEach((obj, places) => {
        if (index !== places && ele?.name === obj?.name) {
          array.push(ele);
        }
      });
    });
    if (isEmpty(array)) {
      setIsCompositionsUnique(isEmpty(array));
      setIsUniqCompId([]);
    }
  }, [compositionsData]);

  const activeInactiveClicked = (id) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);
    const compositionsParams = {
      loggedInUserId,
      materialId: deleteId,
      bomTypeId: bomSubTypeSelectData._id,
      title: materialCompositionComponent,
    };
    await dispatch(action.deleteFromSystemMasters(compositionsParams, t));
    setIsLoadingConf(false);
    setShowConfirmation(false);
    setCompositionsData([...compositionsList]);
    await compositionCalled();
  };

  const activeInactiveConfirmed = async () => {
    setIsLoadingConf(true);
    let comp = {};
    compositionsData?.forEach((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
          bomTypeId: bomSubTypeSelectData._id,
          title: materialCompositionComponent,
        };
        comp = data;
      }
    });
    await dispatch(action.setActiveInactive(comp, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);
    setCompositionsData([...compositionsData]);
  };

  const btnCall = () => {
    if (buttonDownComposition === false) {
      return <i className="icon-new-up" />;
    }
    return <i className="icon-new-down" />;
  };

  const renderTooltipOpenClosevompositions = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {!buttonDownComposition ? t('COMPOSITION_MASTER.CLOSE') : t('COMPOSITION_MASTER.OPEN')}
    </Tooltip>
  );

  const renderTooltipActiveInactive = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('COMPOSITION_MASTER.ACTIVATE_INACTIVATE')}
    </Tooltip>
  );

  const renderTooltipDelete = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('COMPOSITION_MASTER.DELETE')}
    </Tooltip>
  );

  const handleDropdownChangeBomType = (value) => {
    setbomSubTypeSelectData(value);
  };

  const saveCompositions = () => {
    return isComp ? (
      <Spinner animation="border" />
    ) : (
      <>
        <span className="icon-Save c-button-align f-20 mr-2" /> {t('COMPOSITION_MASTER.SAVE')}
      </>
    );
  };

  return (
    <>
      <Accordion className="mb-4 master-accordian">
        <Card>
          <Card.Header>
            <div className="title-container">
              <p>{t('COMPOSITION_MASTER.MODAL_TITLE')}</p>
            </div>
            <div className={!MasterAddEditAccess ? 'action-title-btns single-btn' : 'action-title-btns'}>
              <BtnAdd
                onBtnClick={addComp}
                forDisable={!isCompositionsUnique}
                masterAddEditAccess={MasterAddEditAccess}
                masterDeleteAccess={MasterDeleteAccess}
              />
              <OverlayTrigger placement={t('COMPOSITION_MASTER.AUTOS')} delay={{ show: 250, hide: 400 }} overlay={renderTooltipOpenClosevompositions}>
                <button type="button" onClick={() => callApi()}>
                  {btnCall()}
                </button>
              </OverlayTrigger>
            </div>
          </Card.Header>
          {showComposition &&
            (isLoadingComp ? (
              <Loader />
            ) : (
              <Card.Body>
                <div className="select-container">
                  <Select
                    options={[...BOMTypeList]}
                    placeholder={t('COMPOSITION_MASTER.SELECT_BOM_TYPE')}
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option._id}`}
                    name="bomsubtype"
                    value={bomSubTypeSelectData}
                    onChange={handleDropdownChangeBomType}
                    styles={SystemMasterSelect}
                  />
                </div>
                <PerfectScrollbar
                  containerRef={(ref) => {
                    setScrollEl(ref);
                  }}
                >
                  <ul>
                    {bomSubTypeSelectData &&
                      Object.keys(bomSubTypeSelectData).length !== 0 &&
                      !isEmpty(compositionsData) &&
                      compositionsData.map((comps, compIndex) => {
                        console.log('🚀 ~ compositionsData.map ~ comps:', comps);
                        return (
                          <li key={comps?._id}>
                            <div className="input-container">
                              <input
                                name="bomTypeData"
                                value={comps?.name ? comps?.name : ''}
                                type="text"
                                autoFocus={!comps?._id}
                                placeholder={t('COMPOSITION_MASTER.ENTER_COMPOSITION')}
                                onChange={(e) => handleChanged(e, compIndex)}
                                disabled={!MasterAddEditAccess}
                              />
                              {!isEmpty(isUniqCompId) && isUniqCompId.includes(compIndex) && (
                                <label className="text-danger m-0 p-1">{t('COMPOSITION_MASTER.ENTRY_ALREADY_EXIST')}</label>
                              )}
                              {comps?.isEmpty && (comps?.name === null || comps?.name === '') && (
                                <label className="text-danger m-0 p-1">{t('COMPOSITION_MASTER.COMPOSITION_ENTRY_REQUIRED')}</label>
                              )}
                              {comps?.isNew && !isEmpty(comps?.name) && isEmpty(comps?.name?.trim()) && (
                                <label className="text-danger m-0 p-1">{t('COMPOSITION_MASTER.COMPOSITION_ENTRY_INVALID')}</label>
                              )}
                            </div>
                            <div className="input-action">
                              {comps?._id !== '' && MasterAddEditAccess && (
                                <OverlayTrigger placement={t('COMPOSITION_MASTER.AUTO')} delay={{ show: 250, hide: 400 }} overlay={renderTooltipActiveInactive}>
                                  <button type="button" aria-label="active" onClick={() => activeInactiveClicked(comps?._id)} id={comps?._id}>
                                    <span className={comps?.isActive ? 'icon-active' : 'icon-inactive'} />
                                  </button>
                                </OverlayTrigger>
                              )}
                              {MasterDeleteAccess && (
                                <OverlayTrigger placement={t('COMPOSITION_MASTER.AUTO')} delay={{ show: 250, hide: 400 }} overlay={renderTooltipDelete}>
                                  <button
                                    onClick={() => {
                                      handleDelete(comps?._id ? comps?._id : compIndex);
                                    }}
                                    type="button"
                                    aria-label="delete"
                                  >
                                    <span className="icon-delete mt-3 f-20" />
                                  </button>
                                </OverlayTrigger>
                              )}
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </PerfectScrollbar>
                {MasterAddEditAccess && (
                  <div className="section-save">
                    <CustomTooltip tooltipText={t('common:COMMON_LABEL.SAVE')}>
                      <button
                        aria-label="Save"
                        type="button"
                        className="btn btn-page-filter btn-white"
                        onClick={saveComp}
                        disabled={sTBtnDisable || !isCompositionsUnique}
                      >
                        {saveCompositions()}
                      </button>
                    </CustomTooltip>
                  </div>
                )}
              </Card.Body>
            ))}
        </Card>
      </Accordion>
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('COMPOSITION_MASTER.DELETE_CONFIRM_TITLE')}
          message={t('COMPOSITION_MASTER.DELETE_CONFIRM_MESSAGE')}
          toggle={() => {
            setShowConfirmation(!showConfirmation);
          }}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('COMPOSITION_MASTER.ACTIVATE_DEACTIVATE_CONFIRM_TITLE')}
          message={t('COMPOSITION_MASTER.ACTIVATE_DEACTIVATE_CONFIRM_MESSAGE')}
          toggle={() => {
            setShowConfirmationAD(!showConfirmationAD);
          }}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}
export default CompositionMaster;
